import { ProductPlusPromotion } from '@features/add-to-cart-page/typings/Product';

export enum SummaryItemPaymentType {
  Monthly = 'monthly',
  OneTime = 'one-time'
}

export enum SummaryItemType {
  Accessory = 'accessory',
  Insurance = 'insurance',
  Service = 'service',
  ExtendedWarranty = 'extended-warranty',
  FreeWith = 'free-with',
  Promotion = 'promotion'
}

export type SummaryItem = {
  brand?: { name: string };
  id?: number | string;
  name: string;
  quantity: number;
  salesPrice: {
    includingVat: number;
    excludingVat?: number;
  };
  personalPrice?: {
    price: {
      includingVat: number;
      excludingVat?: number;
    };
    labelText: string;
  };
  paymentType: SummaryItemPaymentType;
  type: SummaryItemType;
  showPrice: boolean;
  promotion?: ProductPlusPromotion;
};
